export default __webpack_public_path__ + "static/media/print-white.a6077b84.svg";